import React, {createContext, useReducer} from "react";
import Reducer from './reducer';
import {Language} from '../Language/index';

const initialState = {
    data: [],
    flash_message_show: false,
    userObj:{},
    lang:Language,
    inbox: null,
    communication: null,
    screenWidth: window.innerWidth,
};

export const Context = createContext(initialState);

const Store = ({children}) => {
    const [state, dispatch] = useReducer(Reducer, initialState);
    return (
        <Context.Provider value={[state, dispatch]}>
            {children}
        </Context.Provider>
    )
};


export default Store;
